'use strict';

/* Pages */
import Main from './main/main.router';
import SignIn from './signin/signin.router';
import SignUp from './signup/signup.router';
import Password from './password/password.router';

/* Modules */
import Dashboard from './dashboard/dashboard.router';
import Challenges from './challenges/challenges.router';
import Devices from './devices/devices.router';
import Groups from './groups/groups.router';
import Locations from './locations/locations.router';
import Notifications from './notifications/notifications.router';
import Orgs from './organizations/organizations.router';
import Reports from './reports/reports.router';
import Users from './users/users.router';
import Billing from './billing/billing.router';
import Profile from './profile/profile';

/* Relative Modules */
import Bots from './bots/bots.router';
import CallCenter from './callcenter/callcenter.router';
import Rules from './rules/rules.router';
import Stories from './stories/stories.router';
import Subscriptions from './subscriptions/subscriptions.router';

export default angular
  .module('modules', [
    Main,
    SignIn,
    SignUp,
    Password,
    Dashboard,
    Bots,
    CallCenter,
    Challenges,
    Devices,
    Groups,
    Locations,
    Notifications,
    Orgs,
    Reports,
    Rules,
    Stories,
    Subscriptions,
    Users,
    Billing,
    Profile,
  ])
  .name;
